import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Text } from "./styles";
import WhiteBorderTop from "../WhiteBorderTop";

export default function Servizi({ setActiveTab, ref }) {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    setOpacity(1);
  }, []);

  return (
    <Container fluid className="w-md-100 associati-container" ref={ref}>
      <Row className="associati-row" style={{ opacity }}>
        <Text
          className="mobile-tab-title associati-title"
          onClick={() => setActiveTab(undefined)}
        >
          Prestazioni
          <WhiteBorderTop />
        </Text>

        <div className="hack col-mattia"> </div>
        <div className="col-about-tab-mobile">
          <Text style={{ lineHeight: "22px" }}>
          Il nostro Studio offre a privati ed enti pubblici prestazioni da architetto e direttore lavori nell’ambito dell’edilizia.
          Siamo inoltre specializzati nell’elaborazione di bandi di concorso e nel coordinamento di concorsi di architettura. 
          Siamo volentieri a disposizione per accompagnarvi nella realizzazione dei vostri progetti in ogni fase del processo: dallo studio di fattibilità e dalla stima dei costi, all'elaborazione del progetto di studio e definitivo, dalla preparazione della domanda di costruzione alla redazione del progetto esecutivo, fino alla realizzazione in cantiere. Offriamo inoltre supporto al committente e la redazione di perizie.
          </Text>
        </div>
      </Row>
    </Container>
  );
}
